import agreementActionKeys from './agreementActionKeys';
import * as service from './agreementService';

const callService = (actionKey, apiMethod, ...params) => ({
  type: actionKey,
  payload: service[apiMethod](...params),
});
export const getAgreementStatus = (userId, pactsafeAccessId) =>
  callService(
    agreementActionKeys.GET_AGREEMENT_STATUS, 'getAgreementStatus', userId,
    pactsafeAccessId,
  );

// when the reducer has been created with the deferLegalRedirect parameter as true,
// then calling this action will allow the reducer to redirect to /app/legal if applicable
// The timing of when this is called does not matter
// (does not need to be coordinated with calls to Pactsafe)
// calling this multiple times has no effect (redirect can only be enabled/disabled dynamically
// once)
export const enableLegalRedirect = () => ({
  type: agreementActionKeys.ENABLE_LEGAL_REDIRECT,
});

// the opposite of enableLegalRedirect. Included for completeness.
export const disableLegalRedirect = () => ({
  type: agreementActionKeys.DISABLE_LEGAL_REDIRECT,
});



// WEBPACK FOOTER //
// ./src/app/common/agreement/agreementActions.js